import { IProjectAttributes } from 'shared/interfaces/IProject';

export const useProjectItemDataParser = (project: IProjectAttributes) => {
  const {
    company,
    name: projectName,
    union,
    casting_roles,
    rate: projectRate,
    opportunities_aggregates,
    project_type,
    working,
    usage,
    noticeboard_project_name,
    noticeboard_company_name,
  } = project;
  const { total_casting_roles_on_notice_board_count, filtered_casting_roles_on_notice_board_count } =
    opportunities_aggregates || {
      total_casting_roles_on_notice_board_count: 0,
      filtered_casting_roles_on_notice_board_count: 0,
    };
  const { name: companyName, addresses, logo: companyLogo } = company || { name: '', addresses: [], logo: null };

  const dates = Boolean(working) && working.dates?.length ? working?.dates[0] : '-';
  const location = working ? working.location : '-';
  const roles = `${filtered_casting_roles_on_notice_board_count} of ${total_casting_roles_on_notice_board_count} roles`;
  const release = usage ? usage : '-';
  const type = project_type || '-';
  const unmatchedRoles = total_casting_roles_on_notice_board_count - filtered_casting_roles_on_notice_board_count;
  const rate = projectRate ? projectRate : '-';
  return {
    noticeboard_project_name,
    noticeboard_company_name,
    companyLogo,
    companyName,
    projectName,
    union,
    dates,
    location,
    roles,
    rate,
    release,
    type,
    casting_roles,
    unmatchedRoles,
    opportunities_aggregates,
  };
};
